
    import { defineComponent } from 'vue';
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import { SaveMultiQuoteNotificationsRequest } from '@/apps/shared/models/saveMultiQuoteNotificationsRequest';
    import checkPricingService from '@/apps/shared/services/checkPricing-service';

    export default defineComponent({
        name: 'travelAssistance-tab-three',
        components: {
            XBreadcrumb,
        },
        data() {
            return {
                breadcrumItems: [
                    { text: 'Inicio', path: '/asistencia-viajero' },
                    { text: 'Datos del Viaje', path: '/asistencia-viajero/datos-viaje' },
                    { text: 'Elegí tu Plan', path: '/asistencia-viajero/plan' },
                ],
                selectedPlanIndex: null as number | null,
                selectedPlanForModal: null as any,
                referente: null,
                plans: [] as any[],
                installments: 1,
                isSingleTrip: false,
            }
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Asistencia al Viajero';
                const actualPath = '/asistencia-viajero';
                const actualStep = 'quoted';

                const dataTabHome = JSON.parse(sessionStorage.getItem("DataTabHome"));
                const travelData = JSON.parse(sessionStorage.getItem("TravelDetailsData"));

                const request = new SaveMultiQuoteNotificationsRequest();
                request.lastName = dataTabHome ? dataTabHome.lastName : '';
                request.firstName = dataTabHome ? dataTabHome.firstName : '';
                request.phone = dataTabHome ? dataTabHome.areaCode + dataTabHome.telephone : '';
                request.mail = dataTabHome ? dataTabHome.email : '';
                request.quotePlan = this.plans.map(plan => plan.name).join(' - ');
                request.quotationDetail = "Producto: " + defaultTitle
                    + " - Destino: " + (travelData && travelData.destination ? travelData.destination.description : '')
                    + " - Tipo de viaje: " + (travelData && travelData.tripType ? travelData.tripType.description : '')
                    + " - Pasajeros: " + (travelData ? travelData.passengersCount : '');

                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, actualStep, request);
                }
                catch (error) {
                    const statusCode = error.response?.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultTravelAssistanceGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },

            selectPlan(plan: any, index: number) {
                // El monto en pesos lo calcula el backend. Si vino 0 (conversión fallida o plan no
                // cobrable), no se puede avanzar al cobro.
                if (!plan.premioMensualPesosACobrar) {
                    NF.Notification.show({
                        type: NF.Notification.Type.ERROR,
                        title: 'Plan no disponible',
                        content: 'No pudimos calcular el precio de este plan. Probá nuevamente más tarde.',
                        position: NF.Notification.Positions.TOP_RIGHT,
                        clickClose: true,
                        autoHideDelay: 8000,
                    });
                    return;
                }

                NF.UI.Page.block();
                this.selectedPlanIndex = index;

                // Guardar plan seleccionado en sessionStorage
                sessionStorage.setItem("SelectedTravelPlan", JSON.stringify(plan));

                const pricingId = Number(plan.pricingId);

                const dataTabHome = JSON.parse(sessionStorage.getItem("DataTabHome"));
                const gtmBase = {
                    'pas': null,
                    'email': dataTabHome ? dataTabHome.email : null,
                    'referente': this.referente,
                    'product': 'asistencia-viaje'
                };

                checkPricingService.checkStatePricing(pricingId).then((response: any) => {
                    if (response.errorMessage == 'Actualizacion correcta') {
                        window.globalThis.dataLayer.push({ ...gtmBase, 'event': 'cotizador-asistencia-viaje-plan', 'plan': plan.name });
                        window.globalThis._qsie = window.globalThis._qsie || [];
                        window.globalThis._qsie.push('cotizador-asistencia-viaje-plan');
                        // Navegar a la pantalla de datos del contratante
                        this.$router.push({ name: 'travelAssistance-policyOwner' });
                    } else {
                        window.globalThis.dataLayer.push({ ...gtmBase, 'event': 'errorServidor', 'paso': 'cotizador-asistencia-viaje-plan' });
                        this.Bus.$emit('show-service-fail', null, [() => this.selectPlan(plan, index)]);
                    }
                }).catch((error) => {
                    window.globalThis.dataLayer.push({ ...gtmBase, 'event': 'errorServidor', 'paso': 'cotizador-asistencia-viaje-plan' });
                    const statusCode = error.response?.status;
                    this.Bus.$emit('show-service-fail', statusCode, [() => this.selectPlan(plan, index)]);
                }).finally(() => {
                    NF.UI.Page.unblock();
                });
            },

            openModalCoberturas(plan: any) {
                this.selectedPlanForModal = plan;
                (this.$refs.modalDataCoberturas as any).open();
            },

            closeModalCoberturas() {
                (this.$refs.modalDataCoberturas as any).close();
            },

            volver() {
                NF.UI.Page.block();
                sessionStorage.setItem("pressBackFromPlans", "true");
                this.$router.push({
                    name: 'travelAssistance-tab-two',
                });
            },

            getInitData() {
                sessionStorage.setItem("ExitOrContinueModal", "true");
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];

                var referente = sessionStorage.getItem("Referente");
                referente == 'null' || referente == null ? this.referente = null : this.referente = referente;

                const travelDataRaw = sessionStorage.getItem("TravelDetailsData");
                const quotationRaw = sessionStorage.getItem("TravelQuotationData");
                if (!travelDataRaw || !quotationRaw) {
                    // Sin cotización guardada: volver a Datos del viaje con lo cargado para cotizar de nuevo
                    sessionStorage.setItem("pressBackFromPlans", "true");
                    this.$router.push({ name: 'travelAssistance-tab-two' });
                    return false;
                }
                const travelData = JSON.parse(travelDataRaw);
                this.installments = travelData.installment ? (Number(travelData.installment.id) || 1) : 1;

                this.isSingleTrip = travelData.tripType != null && String(travelData.tripType.id) === '1';

                const response = JSON.parse(quotationRaw);
                this.plans = (response.plans || []).map(p => {
                    // Coberturas del que me cubre
                    const moduleCovers = (p.moduleCoverages || []).map(c => ({
                        description: c.description,
                        included: c.included,
                        capital: c.capital,
                        capitalFormatted: this.formatUsdInt(c.capital),
                    }));
                    return {
                        id: p.id,
                        name: p.description,
                        pricingId: p.pricingId,
                        premioSegunVigencia: p.premioSegunVigencia,
                        premioMensualPesos: p.premioMensualPesos,
                        premioMensualPesosACobrar: p.premioMensualPesosACobrar,
                        priceFormatted: this.formatUsd(p.premioMensual),
                        priceArsFormatted: p.premioMensualPesosACobrar ? this.formatPriceInt(p.premioMensualPesosACobrar) : '',
                        // Descuento web: cuando hay rango vigente el backend cotiza con y sin descuento.
                        // El ARS mostrado ya sale del premio descontado; el tachado se muestra solo en USD.
                        rate: p.discounts && p.discounts.length ? p.discounts[0].rate : null,
                        undiscountedPriceFormatted: p.premiumWithoutDiscount ? this.formatUsd(p.premiumWithoutDiscount) : '',
                        priceLabel: 'Por viaje',
                        recommended: p.suggestedPlan || false,
                        covers: moduleCovers.slice(0, 6),
                        moduleCovers: moduleCovers,
                    };
                });
                return true;
            },

            formatPrice(value: number): string {
                const n = Number(value) || 0;
                return `$ ${n.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
            },

            formatUsd(value: number): string {
                const n = Number(value) || 0;
                return `U$D ${n.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
            },

            formatUsdInt(value: number): string {
                const n = Number(value) || 0;
                return `U$D ${n.toLocaleString('es-AR', { maximumFractionDigits: 0 })}`;
            },

            formatPriceInt(value: number): string {
                const n = Number(value) || 0;
                return `$ ${n.toLocaleString('es-AR', { maximumFractionDigits: 0 })}`;
            },
        },
        async mounted() {
            try {
                NF.UI.Page.block();

                const ok = this.getInitData();
                if (ok === false) return;
                await this.pageCustomization();
                await this.updateByProductGoogleAnalytics();
            } finally {
                NF.UI.Page.unblock();
            }
        },
    })
